const logMode = true;

export const log = (...args: any) => {
  if (logMode)
    console.log(...args);
}